module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": ""
    }
  }, [_c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#toc2",
      "id": "rtoc2"
    }
  }, [_c('span', {
    staticClass: "cb"
  }, [_vm._v("Preface")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Until the mid 1950s, most people still traveled long distances by rail. Railroads ran all across America, reaching almost every city and town of importance and many that were not. People often had relatives employed by a railroad or knew someone who was. As children they put pennies on the tracks (despite parental warnings that this would cause a wreck) and waved at engineers who waved back. Passenger trains took them to camp in the summer and to distant towns and cities to visit relatives. For generations people often associated train travel with a happier and simpler period of life, and in the fullness of time, passenger trains became embedded in the national psyche. These were “the days when arrival of a train was an exciting event and every little boy was going to be an engineer.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fn01-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fne01-1"
    }
  }, [_vm._v("1")])]), _vm._v(" No other form of public transportation has such a following.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Train travel also offered young people the benefit of socialization. Parents confidently launched their offspring on a trip in the custody of a Pullman conductor who would deliver his charges safely to their destinations; a solo journey on a train was often a rite of passage to adulthood. As essayist E. B. White observed about occupying a Pullman car’s upper berth: “The old act of drawing one’s pants on and off while in a horizontal position did much to keep Man in a mood of decent humility. To tuck in the tails of a shirt while supine demanded a certain persistence, a certain virtuosity, wholly healthful and character-building.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fn01-2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fne01-2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Business and industry depended upon passenger trains and enjoyed their comfort and sophistication, enhanced by prestigious names such as 20th Century Limited, Broadway Limited, Capitol Limited, Denver Zephyr, Super Chief, and City of San Francisco. Vacation and leisure travelers, too, were drawn to trains such as the California Zephyr, Empire Builder, North Coast Limited, and Silver Meteor. It was a time when railroads took pride in their trains, courting passengers with safe, clean, comfortable cars staffed by friendly and courteous employees dedicated to their careers.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f012-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dining aboard a train was treated as a special occasion—initialed tablecloth, china, and silverware were standard, hallmarks of a railroad’s pride of service.")]), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_c('i', [_vm._v("NYC photos, Geoffrey H. Doughty Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f012-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent_parat"
  }, [_vm._v("Overnight train travel frequently included an eagerly anticipated dinner in a rolling restaurant featuring a generous menu. Railroads saw dining cars as both an obligation and an important part of their public image. Tables were set with elegant monogrammed china, silverware, glassware, and linens, carefully arranged on a white tablecloth typically punctuated by a floral arrangement. Traveling aboard such a conveyance could be counted on as relaxing, reliable, and enjoyable. Trains transported us beyond the borders of our own worlds and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("were memorable in part because they were a great way to meet other people. Perhaps this is why so many of the older generation have fond memories of passenger trains.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Two generations and part of a third have grown up never having experienced the pleasure of the well-run privately operated passenger train. To these generations, Amtrak is the standard of passenger rail travel, and what the traveler finds today is by no means all bad. Amtrak has its problems, but its people are doing their best, often in difficult circumstances, and more often than not rise to the occasion and deliver a superior product. Still, this book has been written with a sense of regret about Amtrak’s continuous struggle for survival. It will be abundantly clear that the authors think Amtrak, flaws and all, must survive as part of our national transportation system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("As your grade school report card might have once said of you, Amtrak “needs improvement.” A nation’s strength is often measured by its transportation resources, including its railroad passenger services, and while our society has generally improved its standard of living, our standards of comfortable travel have not kept pace. Amtrak got off to a difficult start mostly because of how it was conceived, the tepid support it received from the rail industry, and the seriously flawed leadership it was given. This book offers insights into the problems Amtrak faced then and still faces, but it starts by exploring the unstoppable post-World War II travel trends that forced the creation of a nationalized railroad passenger system. That history illuminates the need for a balanced national transportation policy that heretofore has been lacking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("As the reader will soon realize, the book is also about leadership and explores steps that could be taken to strengthen Amtrak and ensure its long-term survival. These recommendations go well beyond just “more money” and are set forth in Part Four. The story of Amtrak is much like a jigsaw puzzle with pieces that at first glance do not seem to fit together. But they do fit and make a complete picture. They are important in understanding where Amtrak came from, what it became, and what it might be. Although it is unrealistic to expect a return to the glories of trains past, surely we can find a way to make better the trains we have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("While serving as the Burlington Route’s president between 1932 and 1949, Ralph Budd said of his road’s passenger service, “By making rail travel attractive enough, we have an opportunity to enlarge our passenger business almost indefinitely. A completed trip, if it can be looked back upon with pleasure, should and will encourage another trip.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fn01-3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fne01-3"
    }
  }, [_vm._v("3")])]), _vm._v(" As Amtrak begins a new era providing train travel to another generation, that goal is not beyond reach.")]), _vm._v(" "), _c('p', {
    staticClass: "notex"
  }, [_vm._v("Preface Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "id": "fne01-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fn01-1"
    }
  }, [_vm._v("1")]), _vm._v(". “Railroad Stations on the Block,” "), _c('i', [_vm._v("Berkshire Eagle")]), _vm._v(", August 22, 1956, 22.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "id": "fne01-2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fn01-2"
    }
  }, [_vm._v("2")]), _vm._v(". E. B. White, “Progress and Change,” "), _c('i', [_vm._v("One Man’s Meat")]), _vm._v(" (Gardiner, ME: Tilbury House), 28.")]), _vm._v(" "), _c('p', {
    staticClass: "notex1"
  }, [_c('a', {
    attrs: {
      "id": "fne01-3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Preface#fn01-3"
    }
  }, [_vm._v("3")]), _vm._v(". “Top Passenger Officers Talk Over the Market,” "), _c('i', [_vm._v("Railway Age")]), _vm._v(" 125, no. 13 (September 25, 1948): 46–47.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-312ef520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Preface.vue
// module id = 90
// module chunks = 0